import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {object} from 'yup';

import {Button, Form} from '#component/base';
import {TextInputField} from '#component/partial';
import {emailValidator} from '#util/validator';

import {FieldValues, Props, SubmitHandler} from './ForgotPasswordForm.types';

const signInFormConfig = {
  defaultValues: {email: '', form: ''},
  mode: 'onBlur',
  resolver: yupResolver(object({email: emailValidator})),
} as const;

export const ForgotPasswordForm = ({className, onSubmit, onError}: Props) => {
  const {
    clearErrors,
    formState: {errors, isSubmitting},
    handleSubmit,
    register,
  } = useForm<FieldValues>(signInFormConfig);

  const handleContinue: SubmitHandler = async ({email}) => {
    try {
      await onSubmit({email});
    } catch (error) {
      onError?.(error as any as Error);
    }
  };

  return (
    <Form
      className={className}
      clearErrors={clearErrors}
      errors={errors}
      onSubmit={handleSubmit(handleContinue)}>
      <TextInputField errors={errors} label="Email" {...register('email')} />

      <Button disabled={isSubmitting} icon="ArrowRight" type="submit">
        Submit
      </Button>
    </Form>
  );
};
